<template>
  <section>
    <div class="timer" v-if="timer">
      <header>Aproveite as ofertas disponíveis <b>AGORA</b>, elas se encerram em:</header>
      <div class="clock">
        <div>
          <span>{{ timer.days }}</span>
          <p>Dias</p>
        </div>
        <div>
          <span>{{ timer.hours }}</span>
          <p>Horas</p>
        </div>
        <div>
          <span>{{ timer.minutes }}</span>
          <p>Minutos</p>
        </div>
        <div>
          <span>{{ timer.seconds }}</span>
          <p>Segundos</p>
        </div>
      </div>
    </div>
    <ul class="planos" v-if="planos">
      <li v-for="( plano, i ) in planos" :key="plano" :class="{ selected: plano.selected || plano.selected == 'true' }">
        <input type="radio" name="plano" :value="plano.codigo" class="selector" v-model="plano.planoSelecionado" required/>
        <div>
          <span v-if="plano.tags.interno" class="internoTag">Interno</span>
          <p>Opção {{ i + 1 }}</p>
          <h2 class="color-primary">{{ plano.nome }}</h2>
          <div class="inclui">
            <ul>
              <li v-for="item in produtos[plano.curso.codigo]" :key="item">
                {{ item }}
              </li>
            </ul>
          </div>
          <!-- <div class="valorTotal">
            <div>
              <p>De: <del>{{ formatMoney(plano.totalBruto) }}</del></p>
              <p><b>Por: {{ formatMoney(parseFloat(plano.totalLiquido)) }} <span class="color-success">com {{ plano.percentualDesconto }}% de desconto</span></b></p>
            </div>
          </div> -->
        </div>
        <div>
          <div class="planoBox" v-if="plano.entrada">
            <header>
              Primeira Mensalidade
            </header>
            <div>
              <div class="months">
                <p>{{ plano.entrada.primeiraCompetencia }}</p>
                <div>
                  <span></span>
                  <p v-if="plano.entrada.percentualDesconto > 1">{{ plano.entrada.quantidadeParcelas }} Parcelas com {{ plano.entrada.percentualDesconto }}% de desconto</p>
                  <p v-else>{{ plano.entrada.quantidadeParcelas }} Parcelas</p>
                </div>
                <p>{{ plano.entrada.ultimaCompetencia }}</p>
              </div>
              <div class="price">
                <div>
                  <p>De</p>
                  <p>{{ plano.entrada.quantidadeParcelas }}x de <b><del>{{ formatMoney(plano.entrada.valorParcelaBruto) }}</del></b></p>
                  <p><del>{{ formatMoney(plano.entrada.valorBruto) }}</del></p>
                </div>
                <div>
                  <p>Por</p>
                  <p>{{ plano.entrada.quantidadeParcelas }}x de <b><span>{{ formatMoney(plano.entrada.valorParcelaLiquido) }}</span></b></p>
                  <p>{{ formatMoney(plano.entrada.valorLiquido) }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="planoBox" v-if="plano.mens">
            <header>
              {{ plano.entrada && 'Demais' }} Mensalidades
            </header>
            <div>
              <div class="months">
                <p>{{ plano.mens.primeiraCompetencia }}</p>
                <div>
                  <span></span>
                  <p v-if="plano.mens.percentualDesconto > 1">{{ plano.mens.quantidadeParcelas }} Parcelas com {{ plano.mens.percentualDesconto }}% de desconto</p>
                  <p v-else>{{ plano.mens.quantidadeParcelas }} Parcelas</p>
                </div>
                <p>{{ plano.mens.ultimaCompetencia }}</p>
              </div>
              <div class="price">
                <div>
                  <p>De</p>
                  <p>{{ plano.mens.quantidadeParcelas }}x de <b><del>{{ formatMoney(plano.mens.valorParcelaBruto) }}</del></b></p>
                  <p><del>{{ formatMoney(plano.mens.valorBruto) }}</del></p>
                </div>
                <div>
                  <p>Por</p>
                  <p>{{ plano.mens.quantidadeParcelas }}x de <b><span>{{ formatMoney(plano.mens.valorParcelaLiquido) }}</span></b></p>
                  <p>{{ formatMoney(plano.mens.valorLiquido) }}</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <a href="#" class="btn btn-secondary" @click.prevent="toggleMens(i)">
              {{ plano.showMens ? 'Esconder' : 'Ver' }} Mensalidades
            </a>
          </div>
          <div class="planoBox mensWrap" v-if="plano.showMens">
            <table class="mensalidades">
              <thead>
                <tr>
                  <th></th>
                  <th>Competência</th>
                  <th>Desconto</th>
                  <th>Mensalidade</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(mens, i) in plano.mensalidades" :key="mens">
                  <td>{{ `${i + 1}.` }}</td>
                  <td>{{ mens.competencia }}</td>
                  <td>{{ mens.descontoPercent }}%</td>
                  <td v-if="mens.descontoPercent > 0"><span>de <del>{{ formatMoney(mens.valorBruto) }}</del></span> por {{ formatMoney(mens.valorLiquido) }}</td>
                  <td v-else>{{ formatMoney(mens.valorLiquido) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="discountMessage">
            <fa :icon="['fas','badge-dollar']" class="icon"></fa>
            <p>Você economiza {{ formatMoney(plano.valorDesconto) }}</p>
          </div>
        </div>
        <a href="#" @click.prevent="selectPlano(plano, i)">
          {{ plano.selected ? 'Selecionado' : 'Matricule-se já!' }}
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
// import UserService from '@/services/user.service'
import AcademicoService from '@/services/academico.service'
import MatriculaService from '@/services/matricula.service'
// import FormService from '@/services/form.service'
import { formatMoney, formatDate, unformatDate } from '@/services/utils.service'
import moment from 'moment'

export default {
  components: {

  },
  props: {
    auto: {
      type: Boolean,
      default: false
    },
    idMatricula: {
      type: [ Number, String ]
    },
    action: {
      type: String
    }
  },
  data () {
    return {
      options:{
        turmas: null,
        vencimentos: [
          { label: '5', value: 5 },
          { label: '10', value: 10 }
        ],
        meses: {
          1: 'jan',
          2: 'fev',
          3: 'mar',
          4: 'abr',
          5: 'mai',
          6: 'jun',
          7: 'jul',
          8: 'ago',
          9: 'set',
          10: 'out',
          11: 'nov',
          12: 'dez'
        },
        arrecadacoes: {
          'ENT': 'entrada',
          'MEN': 'mensalidades',
          'ANU': 'anuidade'
        }
      },
      wait: {
        // turmas:  false,
        planosPagamento: false
      },
      matricula: null,
      planos: null,
      planoModel: null,
      planoSelecionado: null,
      produtos: {
        EFI: ["Serviços Escolares", "Apostilas do Sistema de Ensino", "Recursos Digitais Interativos", "Projetos Exclusivos"],
        EFII: ["Serviços Escolares", "Apostilas do Sistema de Ensino", "Recursos Digitais Interativos", "Projetos Exclusivos"],
        EM: ["Serviços Escolares", "Apostilas do Sistema de Ensino", "Recursos Digitais Interativos", "Projetos Exclusivos"],
        EDF: ["Serviços Escolares", "Apostilas do Sistema de Ensino", "Recursos Digitais Interativos", "Projetos Exclusivos"],
        CPM: ["Serviços Escolares", "Recursos Digitais Interativos", "Projetos Exclusivos", "Alimentação"],
        CPME: ["Serviços Escolares", "Recursos Digitais Interativos", "Projetos Exclusivos"]
      },
      timer: null
    }
  },
  mounted () {
    window.spinner.emit("open")

    this.$store.dispatch('matricula/get').then(response => {
      console.log("matricula:", response)
      this.matricula = response
      this.forceGetPlanos()
    })
  },
  methods: {
    forceGetPlanos() {
      if ( this.matricula.matricula.idSituacao == 1 ) {
        this.getPlanosPagamento(this.matricula.matricula.idMatricula)
      } else {
        this.getPlanosPagamentoIdSerie(this.matricula.matricula.idSerie)
      }
    },
    getTurmas ( serie ) {
      this.loadingFilterData = true
      AcademicoService.getTurmas(serie).then(
        response => {
          console.log("getTurmas:", response.data)
          this.options.turmas = response.data

          this.wait.turmas = true
          this.loadingFilterData = false

          this.stopSpinner()
        },
        error => {
          console.error(error)
          this.loadingFilterData = false
        }
      )
    },
    getPlanosPagamento ( idMatricula ) {
      idMatricula = idMatricula ? idMatricula : this.matricula.matricula.idMatricula
      window.spinner.emit("open")
      MatriculaService.getPlanosPagamento(idMatricula).then(
        response => {
          console.log("getPlanosPagamento", response)
          this.wait.planosPagamento = true

          this.stopSpinner()
        },
        error => {
          console.error(error)
        }
      ).finally(() => {
        window.spinner.emit("close")
      })
    },
    getPlanosPagamentoIdSerie ( idSerie ) {
      window.spinner.emit("open")
      MatriculaService.getPlanosPagamentoIdSerie(idSerie, this.matricula.matricula.idMatricula).then(
        response => {
          console.log("getPlanosPagamentoIdSerie", response)
          this.planos = response.data.data
          this.wait.planosPagamento = true
          this.processPlanos()
          this.syncSelectedPlano()
          this.stopSpinner()
        },
        error => {
          console.error(error)
        }
      )
      .finally(() => {
        window.spinner.emit("close")
      })
    },
    processPlanos () {
      const calcularGrupo = (items = []) => {
        const totalBruto = items.reduce((total, item) => {
          return total + Number(item.valorBruto || 0)
        }, 0)

        const totalLiquido = items.reduce((total, item) => {
          return total + Number(item.valorLiquido || 0)
        }, 0)

        const valorDesconto = totalBruto - totalLiquido

        const percentualDesconto = totalBruto > 0
          ? (valorDesconto / totalBruto) * 100
          : 0

        const quantidadeParcelas = items.length

        return {
          valorBruto: Number(totalBruto.toFixed(2)),
          valorLiquido: Number(totalLiquido.toFixed(2)),

          valorParcelaBruto: quantidadeParcelas > 0
            ? Number((totalBruto / quantidadeParcelas).toFixed(2))
            : 0,

          valorParcelaLiquido: quantidadeParcelas > 0
            ? Number((totalLiquido / quantidadeParcelas).toFixed(2))
            : 0,

          quantidadeParcelas,

          percentualDesconto: Number(percentualDesconto.toFixed(2)),
          valorDesconto: Number(valorDesconto.toFixed(2)),

          primeiraCompetencia: items[0]?.competencia || null,
          ultimaCompetencia: items[items.length - 1]?.competencia || null
        }
      }

      const somaLiquidaGrupo = (items = []) => {
        return items.reduce((total, item) => {
          return total + Number(item.valorLiquido || 0)
        }, 0)
      }

      let endDate = null

      this.planos.forEach(k => {
        if (!endDate) endDate = k.dataFim

        k.showMens = false
        // k.selected = false

        const parcelas = k.mensalidades || []

        const parcelasOrdenadas = [...parcelas].sort((a, b) => {
          return a.competencia.localeCompare(b.competencia)
        })

        const totalGeral = calcularGrupo(parcelasOrdenadas)

        k.totalBruto = totalGeral.valorBruto
        k.totalLiquido = totalGeral.valorLiquido
        k.valorDesconto = totalGeral.valorDesconto
        k.percentualDesconto = totalGeral.percentualDesconto

        const gruposPorAno = parcelasOrdenadas.reduce((acc, item) => {
          const ano = item.competencia.split('/')[0]

          if (!acc[ano]) acc[ano] = []
          acc[ano].push(item)

          return acc
        }, {})

        const gruposValidos = Object.keys(gruposPorAno)
          .sort()
          .map(ano => gruposPorAno[ano])
          .filter(grupo => somaLiquidaGrupo(grupo) > 0)

        if (gruposValidos.length > 1) {
          k.entrada = calcularGrupo(gruposValidos[0])
          k.mens = calcularGrupo(gruposValidos[1])
        } else {
          k.entrada = null
          k.mens = calcularGrupo(gruposValidos[0] || parcelasOrdenadas)
        }
      })

      this.runTimer(endDate)
      this.wait.planosPagamento = true

      console.log('planos:', this.planos)
    },
    isPlanoSelecionado ( plano ) {
      return plano?.selected === true ||
        plano?.selected == 'true' ||
        plano?.selected == 1 ||
        plano?.selected == '1'
    },
    syncSelectedPlano () {
      const plano = this.planos?.find(item => this.isPlanoSelecionado(item))

      if ( plano ) {
        this.planoSelecionado = plano.codigo
        this.matricula.planoPagamento = plano
        this.matricula.planoPag = plano
      }
    },
    sumValuesByDate(data) {
      return Object.values(data.reduce((acc, object) => {
        console.log('object:', object)
        const type = object.siglaFront

        acc[type] = acc[type] || { 
          dataFinal: object.dataFinal,
          dataInicio: object.dataInicio,
          mesInicio: object.mesInicio,
          valorTotal: 0,
          valorTotalDesconto: 0,
          valorParcela: 0,
          valorParcelaDesconto: 0,
          mesFinal: null,
          numeroParcelas: object.numeroParcelas,
          tipo: object.siglaFront
        }
        acc[type].valorTotal += Number(object.valorTotal)
        acc[type].valorTotalDesconto += Number(object.valorTotalDesconto)
        acc[type].valorParcela += Number(object.valorParcela)
        acc[type].valorParcelaDesconto += Number(object.valorParcelaDesconto)

        const parseMesInicio = object.mesInicio.split("/")
        const mesInicio = parseFloat(parseMesInicio[0])
        const mesFinal = mesInicio + ( object.numeroParcelas - 1 )
        acc[type].mesFinal = mesFinal + '/' + parseMesInicio[1]
        
        console.log("acc:", acc)
        return acc
      }, {}))
    },
    dropDate ( date ) {
      const parsed = date.split('/')
      const year = parsed[1].slice(-2)
      return this.options.meses[parseFloat(parsed[0])] + '/' + year
    },
    getAluno () {
      this.$store.dispatch('matricula/get').then(response => {
        this.matricula = response
        if ( this.idMatricula ) {
          MatriculaService.getAlunoByIdMatricula( this.idMatricula ).then(
            response => {
              // console.log("getAuno:", response.data)
              this.matricula.Aluno.Aluno = response.data.aluno.Aluno ? response.data.aluno.Aluno : this.matricula.Aluno.Aluno
              this.matricula.Aluno.Basicos = response.data.aluno.Basicos ? response.data.aluno.Basicos : this.matricula.Aluno.Basicos
              this.matricula.Aluno.Basicos.dataNascimento = this.matricula.Aluno.Basicos.dataNascimento ? unformatDate(this.matricula.Aluno.Basicos.dataNascimento) : this.matricula.Aluno.Basicos.dataNascimento
              this.matricula.Aluno.Documento = response.data.aluno.Documento ? response.data.aluno.Documento : this.matricula.Aluno.Documento
              this.matricula.Aluno.Endereco = response.data.aluno.Endereco ? response.data.aluno.Endereco : this.matricula.Aluno.Endereco
              
              this.matricula.matricula = response.data.matricula ? response.data.matricula : this.matricula.matricula

              if ( !this.matricula.Aluno.Basicos.nomeDocumento ) {
                this.matricula.Aluno.Basicos.nomeDocumento = this.matricula.Aluno.Basicos.nome
              }
              
              if ( !this.matricula.Aluno.Basicos.nomeDocumento ) {
                this.matricula.Aluno.Basicos.nomeDocumento = this.matricula.Aluno.Basicos.nome
              }
              
              this.$store.dispatch('matricula/save', this.steps).then(() => {
                 this.getTurmas(this.matricula.matricula.idSerie)
              })
              
            },
            error => {
              console.error(error.response.data.message)
            }
          )
        } else {
          this.loaded = true
          this.$emit('ready')
        }
      })      
    },
    stopSpinner () {
      const done = !Object.values(this.wait).includes(false)
      if ( done ) {
        setTimeout(() => {
          window.spinner.emit("close")
          this.$emit('ready')
        },1000)
      }
    },
    validate () {
      const valid = this.matricula.planoPag.idprecificacao ? true : false

      if ( !valid ) {
        window.toaster.emit('open', {style: "error", message: "Para continuar, escolha o plano de pagamento.", floater: true})
      }

      return { response: valid }
      // return valid
    },
    parseFirstName( name ) {
      const nome = name.split(" ")[0]
      return nome
    },
    filterTurma ( idTurma,src ) {
      // console.log('filter turma:', idTurma)

      const turma = this.options.turmas.filter( k => {
        return k.idTurma == idTurma
      })[0]

      // console.log('turma:', turma)

      const drop = turma[src]

      // console.log('drop:', drop)

      return drop
    },
    clearSelection () {
      this.planos.map( k => {
        k.selected = false
      })
    },
    selectPlano ( plano ) {
      this.planoSelecionado = plano.codigo

      this.planos.forEach(p => {
        p.selected = false
      })

      plano.selected = true

      this.$nextTick(() => {
        const radio = this.$el.querySelector(
          `input[type="radio"][name="plano"][value="${plano.codigo}"]`
        )

        if (radio) {
          radio.checked = true

          radio.dispatchEvent(new Event('change', {
            bubbles: true
          }))

          this.matricula.planoPagamento = plano
        }
      })
    },
    formatMoney ( value ) {
      return formatMoney(value)
    },
    formatDate ( value ) {
      return formatDate(value)
    },
    calcDiscountDif ( plano ) {
      const valorTotal = parseFloat(plano.valorTotal)
      const valorTotalDesconto = parseFloat(plano.valorTotalDesconto)

      const dif = valorTotal - valorTotalDesconto
      return dif
    },
    filterEntrada ( plano ) {
      const filterEntrada = plano.planosPagamento.filter(k => {
        return k.tipoArrecadacao == 'Entrada'
      })
      // console.log("filterEntrada:", filterEntrada)
      return filterEntrada
    },
    filterMensalidade ( plano ) {
      const filterMensalidade = plano.planosPagamento.filter(k => {
        return k.tipoArrecadacao == 'Mensalidade'
      })
      // console.log("filterMensalidade:", filterMensalidade)
      return filterMensalidade
    },
    filterAnuidade ( plano ) {
      const filterAnuidade = plano.planosPagamento.filter(k => {
        return k.tipoArrecadacao == 'Anuidade'
      })
      console.log("filterAnuidade:", filterAnuidade)
      return filterAnuidade
    },
    trackSelectedPlan () {
      this.planos.map( k => {
        console.log('k',k)
        if ( k.selected ) this.matricula.planoPag = k
      })
    },
    toggleDescontos () {
      this.$emit('toggleDescontos')
    },
    toggleMens ( i ) {
      this.planos[i].showMens = !this.planos[i].showMens
    },
    createTimer ( targetDate ) {
      // const response = await fetch('/api/server-time')
      // const { now } = await response.json()
      const now = moment()

      const serverStart = new Date(now).getTime()
      const performanceStart = performance.now()
      const target = new Date(targetDate).getTime()

      function getTimeLeft() {
        const currentServerTime = serverStart + (performance.now() - performanceStart)
        const diff = Math.max(0, target - currentServerTime)

        const days = Math.floor(diff / (1000 * 60 * 60 * 24))
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24)
        const minutes = Math.floor((diff / (1000 * 60)) % 60)
        const seconds = Math.floor((diff / 1000) % 60)

        return { days, hours, minutes, seconds }
      }

      return getTimeLeft
    },
    runTimer( targetDate ) {
      const timer = this.createTimer(targetDate)
      const self = this
      setInterval(() => {
        self.timer = timer()
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .planos {
    display: flex; flex-wrap: wrap;
    align-content: center; align-items: flex-start;
    gap: $hmg_mid;
    padding: 0; margin: $mg 0 0 0;
    justify-content: center;

    >li {
      display: flex; align-items: stretch;
      flex-direction: column;
      border-radius: $border-radius-large;
      border: $border-component; 
      background-color: $color-secondary;
      list-style: none; margin: 0;
      width: 35%;  position: relative;
      
      input[type=radio] {
        visibility: hidden;
        position: absolute;
      }

      @media screen and (max-width: 1024px) {
        width: 100%;
      }

      >div {
        padding: 0 $hmg_mid;

        &:first-child {
          padding: $hmg_mid;
          border-bottom: $border-component;
        }

        &:nth-child(2) {
          padding-top: $hmg_mid;
        }

        >h2 { 
          max-width: 70%;
          @media screen and (max-width: 1024px) {
            max-width: 100%;
          }
        }

        .valorTotal {
          p {
            margin: 0; padding: 0;

            &:last-child {
              font-size: $font-size-larger
            }
          }
        }
        
        .discountMessage {
          display: flex; align-items: center;
          font-weight: bold; gap: $hmg_mini;
          margin: $hmg_mid 0;
          font-size: $font-size-large;
          .icon {
            font-size: 20px;
            color: $color-success-2;
          }

          p {
            margin: 0;
          }
        }

        .planoDiscount {
          padding: $mg_mini;
          border-radius: $border-radius;
          background-color: $color-bg;
          margin-top: $hmg_mid;

          >span {
            display: block;
          }
        }

        .validThru {
          margin-top: $hmg_mid;

          p {
            margin: 0;
          }
        }

        >div {
          a {
            width: 100%;
          }
        }
      }

      >a:not(.toggleCalc) {
        display: flex;
        width: 100%;
        height: 50px;
        align-items: center;
        align-content: center;
        justify-content: center;
        background-color: $color-primary;
        margin-top: $hmg_mid;
        font-size: 18px; text-transform: uppercase; font-weight: bold;
        color: $color-secondary;
        border-bottom-left-radius: $border-radius-large;
        border-bottom-right-radius: $border-radius-large;
        @extend %transition_4e;

        &:hover {
          height: 60px;
        }
      }

      &.selected {
        border: 1px solid $color-success-2 !important;

        a:not(.toggleCalc) {
          background-color: $color-success-2;
        }
      }

      .planoBox {
        border-radius: $border-radius;
        border: $border-component;
        overflow: hidden;
        margin-bottom: $hmg_mid;

        &.mensWrap {
          margin-top: $hmg_mid;
        }

        &:last-child {
          margin-bottom: 0;
        }

        header {
          padding: $hmg_small;
          border-bottom: $border-component;
          font-size: 20px; font-weight: bold;
          text-align: center !important;
          background-color: $color-bg
        }
        > div {
          padding: $hmg_mid;
        }

        .mensalidades {
          padding: 0; margin: 0;
          border-collapse: collapse;
          // table-layout: fixed;
          width: 100%;

          thead {
            th {
              font-size: $font-size-small;
              font-weight: bold;
              padding: $hmg_mini;

              &:first-child {
                width: 30px;
                padding-left: $mg_mini;
              }
            }
          }

          tbody {
            tr {
              td{
                padding: $hmg_mini;
                border-top: $border-component;

                span {
                  display: block;
                  font-size: $font-size-small;
                }

                &:first-child {
                  width: 30px;
                  padding-left: $mg_mini;
                }
              }
            }
          }
        }
      }
      // display: flex; flex-direction: column; align-content: center; align-items: flex-start;
      // list-style: none; position: relative;
      // border-right: 1px solid $color-fade;
      // padding: $hmg_small $hmg; margin: $mg 0 0 0;
      // width: 33.333333%; min-width: 240px; max-width: 360px !important;

      // @media screen and ( max-width: 640px ) {
      //   border-right: 0; border-bottom: 1px solid $color-fade;
      //   margin: 0 0 $mg 0; width: 100%;
      //   padding: $hmg $hmg $mg;
      // }
      
      

      .btn-check {
        width: calc(100% + $mg_mid);
        margin-top: $hmg; margin-left: -$hmg_small;
      }

      h2 {
        margin-bottom: $hmg_mid;
      }

      .planosContent {
        display: flex; align-content: center; align-items: center;
        justify-content: space-between;
        width: 100%;

        >span {
          &:last-child {
            text-align: right;
          }
          &:first-child {
            text-align: left !important;
          }
          p {
            font-size: $font-size-larger; margin: 0;
          }

          &.large {
            p {
              font-size: 16px;
            }
          }
        }
      }

      .planoCardHeader {
        margin-bottom: $hmg_mini;

        h5 {
          margin: 0;
        }
      }

      .planoCard {
        width: calc( 100% + $mg_mid );
        margin-left: -$hmg_small;
        background-color: $color-secondary;
        border-radius: $border-radius;
        padding: $hmg_small;
        position: relative;

        footer {
          height: 37px; width: 100%;
          position: absolute; bottom: 0; left: 0;
          background-color: $color-success-2;
          display: flex; align-content: center; align-items: center; justify-content: space-between;
          font-weight: bold;
          padding: 0 $hmg_small;
          border-bottom-left-radius: $border-radius; border-bottom-right-radius: $border-radius;

          p {margin: 0; white-space: nowrap;}
        }

        &.hasFooter {
          padding-bottom: calc($hmg_small + 37px);
        }
      }

      

      .btDiscountDetails {
        font-size: 20px;

        .icon {
          @extend %transition_4e;
        }

        &:hover {
          .icon {
            transform: scale(1.1);
          }
        }
      }

      .planoDetails {
        width: 100%; margin-bottom: $hmg_mid;
      }

      .due {
        font-size: $font-size-larger;
        margin-top: $mg;

        @media screen and ( max-width: 640px ) {
          margin-top: $hmg;
        }

        p {
          margin: 0
        }
      }
    }
  }

  .dueDateSelect {
    display: flex; align-items: center; align-content: center;
    background-color: $color-secondary;
    border-radius: $border-radius;
    padding: $mg_mini $hmg_small;

    label {
      margin: 0; padding: 0;
    }
    select {
      appearance: none;
      padding: 0; margin: 0;
      line-height: 1;
      outline: 2px solid $color-primary;
      border: 0; margin-left: $hmg_small;
      color: $color-text; font-weight: bold;
      width: 26px; height: 26px; border-radius: 100%;
      background-color: $color-bg;
      text-align: center;

      option {
        padding: 0; margin: 0;
        line-height: 1;
      }
    }
  }

  .counterTag {
    // position: absolute; top: 0; left: 0;
    padding: $hmg_mini $hmg_small;
    border-radius: $border-radius;
    transform: translateY(-100%);
    margin-left: -$hmg_small;
    background-color: $color-secondary;
    @extend %shadow-low-light;
  }

  .months {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: $mg_mini;
    
    >p{
      margin: 0; padding: 0;
    }
    
    >div {
      flex: 1;
      position: relative;

      span {
        width: 100%; height: 1px;
        background-color: $color-bg;
        display: block;
      }
      p {
        margin: 0;
        padding: 0;
        position: absolute;
        left: 0; right: 0;
        margin: auto;
        transform: translateY(10px);
        font-weight: bold;
        text-align: center;
      }
    }
  }

  .price {
    display: flex; width: 100%;
    margin-top: $hmg;
    align-items: flex-start; align-content: flex-start;
    justify-content: space-between;
    // gap: $hmg_mid;

    > div {
      // flex: 1;

      &:first-child {
        p {
          color: $color-mid-grey;
          padding-right: $hmg_mini
        }
      }

      &:last-child{
        text-align: right;

        p {
          padding-left: $hmg_mini
        }
      }

      p {
        display: block;
        margin: 0; padding: 0;  

        &:nth-child(1) {
          font-weight: bold;
          margin-bottom: 3px;
        }
        &:nth-child(2) {
          font-size: $font-size-larger;
          border-bottom: $border-component;

          span {
            color: $color-success-2
          }
        }
        &:nth-child(3) {
          margin-top: 3px;
        }
        &:last-child {
          border-bottom: 0 !important;

          span {
            color: $color-success-2
          }
        }
      }
    }
  }

  .internoTag {
    display:  inline-flex; align-content: center; justify-content: center;
    margin-bottom: $hmg_mid;
    padding: $hmg_mini $mg_mini;
    border-radius: 2em;
    background-color:  $color-primary;
    color: $color-secondary
  }

  .toggleCalc {
    display: flex; align-content: center; align-items: center;
    justify-content: center; 
    line-height: 1; font-size: 16px;
    width: 40px; height: 40px;
    position: absolute; right: $hmg_mid; top: $hmg_mid;
    border-radius: 100%;
    @extend %transition_3o;

    &:hover {
      background-color: $color-bg
    }
  }

  .inclui {
    padding: $hmg_mid 0;

    ul {
      padding: 0; margin: 0;

      li {
        padding: 0; margin: 0;
        width: 100%;
        border: 0 !important;
        list-style: inside;
        line-height: 20px;
        
        &::marker {
          color: $color-primary;
        }
      }
      li::marker {
        color: $color-primary;
      }
    }
  }

  .timer {
    margin: auto;
    text-align: center;
    max-width: 440px;
    padding: 0 $hmg_mid;

    header {
      max-width: 320px;
      padding: 0 $hmg_mid;
      margin: auto;
    }
    .clock {
      display: flex;
      align-items: center;
      gap: $hmg_mini;
      margin: $hmg_mid auto;
      justify-content: center;

      div {
        >span {
          display: inline-flex;
          width: 70px; height: 70px;
          justify-content: center;
          font-size: 3rem;
          font-weight: bold;
          background-color: $color-primary;
          color: $color-secondary;
          text-align: center;
          line-height: 1;
          align-items: center;
          border-radius: $border-radius;
        }
        p {
          margin: 0; padding: $hmg_mini 0;
          text-align: center;
          font-size: $font-size-small;
          font-weight: bold;
        }
      }
      
    }
  }
</style>
